export const CASE_SITUATIONS = {
    PENDING_GROSSING: 'PENDING_GROSSING',
    PENDING_LABORATORY: 'PENDING_LABORATORY',
    PENDING_INFORM: 'PENDING_INFORM',
    PENDING_TRANSCRIPTION: 'PENDING_TRANSCRIPTION',
    PENDING_VALIDATION: 'PENDING_VALIDATION',
    PENDING_ADDITIONAL_ASSAYS: 'PENDING_ADDITIONAL_ASSAYS',
    PENDING_COMPLEMENTARY: 'PENDING_COMPLEMENTARY',
    PENDING_AMENDMENT: 'PENDING_AMENDMENT',
    ALL_PENDING_DASHBOARD: 'ALL_PENDING_DASHBOARD',
    SHARED_BY_ME: 'SHARED_BY_ME',
    SHARED_WITH_ME: 'SHARED_WITH_ME',
    QUALITY: 'QUALITY',
    VALIDATED: 'VALIDATED'
}
